import { Box } from '@mantine/core';
import { CustomerTable } from './Customer-Table/CustomerTable';
import ModalCustomers from './Customers-Modal/ModalCustomers';
import { LIGHT_GREY_BG } from '../../constants/colors';
import { useContext } from 'react';
import SingleCustomerContext from './Customer-Context/SingleCustomerContext';
import IconsLine from './IconsLine';
import CustomerHeader from './Customer-Table/Header/CustomerHeader';
import MainTitle from './Customer-Table/Header/MainTitle';
import CustomDrawerCustomers from './Drawer/CustomDrawerCustomers';

export default function CustomerView() {

  const { isModalOpen, closeModal } = useContext(SingleCustomerContext);

  return (
    <Box 
      py={10} 
      px={16} 
      bg='white'
      sx={{
        minHeight: 'calc(100vh - 63px)',
        backgroundColor: 'white'
      }}
    >
      <Box mb={12}>
        <MainTitle />
      </Box>
      <Box
        px={20}
        pt={10}
        sx={{borderRadius: 4}}
        h={106} 
        mb={24} 
        bg={LIGHT_GREY_BG} 
        w="100%">
        <CustomerHeader />
      </Box>
      
      <CustomerTable isModalOpen={isModalOpen} />
      { isModalOpen && <ModalCustomers opened={isModalOpen} close={closeModal}/> }
      {/* <CustomDrawer componentType="customer"/> */} 
      <CustomDrawerCustomers />
      <IconsLine />
    </Box>
  );
}